import { ComponentProps } from 'react';
import {
  LeaderBoardCell,
  LeaderBoardCellProps,
  LeaderBoardCellVariant,
  LeaderBoardLabel,
  LeaderBoardLabelProps,
} from './Elements';
import { twMerge } from 'tailwind-merge';

export interface LeaderBoardRow extends Omit<LeaderBoardCellProps, 'className'> {
  variant?: LeaderBoardCellVariant;
}

export interface LeaderBoardProps extends ComponentProps<'div'> {
  rows?: LeaderBoardRow[];
  showHeader?: boolean;
  labelProps?: Omit<LeaderBoardLabelProps, 'className'>;
  labelClassName?: string;
  rowClassName?: string;
  showAverage?: boolean;
  showGameweekPoints?: boolean;
}

const defaultRows: LeaderBoardRow[] = [
  {
    variant: 'myScore',
    rank: '300000',
    username: '{Username}',
    average: '128.9',
    gameweekPoints: '93',
    total: '2838',
    booster: true,
  },
  {
    variant: 'default',
    rank: '1',
    teamName: 'Team Name Here',
    managerName: '-',
    average: '128.9',
    gameweekPoints: '120',
    total: '2838',
  },
  {
    variant: 'default',
    rank: '2',
    teamName: 'Sky Warriors',
    managerName: 'B. Thompson',
    average: '133.5',
    gameweekPoints: '125',
    total: '2900',
    booster: true,
  },
  {
    variant: 'default',
    rank: '3',
    teamName: 'Tech Titans',
    managerName: 'J. Smith',
    average: '150.2',
    gameweekPoints: '140',
    total: '3100',
    booster: true,
  },
  {
    variant: 'default',
    rank: '4',
    teamName: 'Innovators United',
    managerName: 'A. Johnson',
    average: '145.7',
    gameweekPoints: '135',
    total: '3050',
  },
  {
    variant: 'default',
    rank: '5',
    teamName: 'Future Builders',
    managerName: 'K. Lee',
    average: '128.3',
    gameweekPoints: '130',
    total: '2950',
    booster: true,
  },
  {
    variant: 'default',
    rank: '6',
    teamName: 'Creative Minds',
    managerName: 'M. Brown',
    average: '138.6',
    gameweekPoints: '125',
    total: '3000',
    booster: true,
  },
  {
    variant: 'default',
    rank: '7',
    teamName: 'Dynamic Duos',
    managerName: 'L. Garcia',
    average: '139.9',
    gameweekPoints: '132',
    total: '2800',
  },
  {
    variant: 'default',
    rank: '8',
    teamName: 'Pioneers Club',
    managerName: 'S. Martinez',
    average: '142.2',
    gameweekPoints: '134',
    total: '2700',
  },
  {
    variant: 'default',
    rank: '9',
    teamName: 'Visionaries',
    managerName: 'C. Robinson',
    average: '146.4',
    gameweekPoints: '138',
    total: '2850',
  },
  {
    variant: 'default',
    rank: '10',
    teamName: 'Trailblazers',
    managerName: 'D. Wilson',
    average: '130.1',
    gameweekPoints: '126',
    total: '2750',
  },
  {
    variant: 'default',
    rank: '11',
    teamName: 'Next Gen Leaders',
    managerName: 'E. Anderson',
    average: '149.8',
    gameweekPoints: '140',
    total: '3100',
  },
  {
    variant: 'default',
    rank: '12',
    teamName: 'Bold Innovators',
    managerName: 'F. Thomas',
    average: '154.3',
    gameweekPoints: '145',
    total: '3200',
  },
  {
    variant: 'default',
    rank: '13',
    teamName: 'Synergy Squad',
    managerName: 'G. Jackson',
    average: '135.2',
    gameweekPoints: '128',
    total: '2900',
  },
  {
    variant: 'default',
    rank: '14',
    teamName: 'Collaborative Minds',
    managerName: 'H. White',
    average: '140.5',
    gameweekPoints: '132',
    total: '3000',
  },
  {
    variant: 'default',
    rank: '15',
    teamName: 'The Achievers',
    managerName: 'I. Harris',
    average: '145.1',
    gameweekPoints: '135',
    total: '3100',
  },
  {
    variant: 'default',
    rank: '16',
    teamName: 'Winning Streak',
    managerName: 'J. Clark',
    average: '150.9',
    gameweekPoints: '140',
    total: '3200',
  },
  {
    variant: 'default',
    rank: '17',
    teamName: 'Impact Makers',
    managerName: 'K. Lewis',
    average: '152.4',
    gameweekPoints: '142',
    total: '3300',
  },
  {
    variant: 'default',
    rank: '18',
    teamName: 'Courageous Crew',
    managerName: 'L. Lee',
    average: '139.7',
    gameweekPoints: '133',
    total: '3000',
  },
  {
    variant: 'default',
    rank: '19',
    teamName: 'Resilient Team',
    managerName: 'M. Walker',
    average: '137.8',
    gameweekPoints: '130',
    total: '2950',
  },
  {
    variant: 'default',
    rank: '20',
    teamName: 'Aspire Together',
    managerName: 'N. Hall',
    average: '148.5',
    gameweekPoints: '140',
    total: '3100',
  },
  {
    variant: 'default',
    rank: '21',
    teamName: 'United Force',
    managerName: 'O. Allen',
    average: '150.0',
    gameweekPoints: '145',
    total: '3200',
  },
  {
    variant: 'default',
    rank: '22',
    teamName: 'The Enthusiasts',
    managerName: 'P. Young',
    average: '135.5',
    gameweekPoints: '135',
    total: '2900',
  },
  {
    variant: 'default',
    rank: '23',
    teamName: 'Synergy Innovators',
    managerName: 'Q. King',
    average: '138.1',
    gameweekPoints: '128',
    total: '2750',
  },
  {
    variant: 'default',
    rank: '24',
    teamName: 'Brilliant Thinkers',
    managerName: 'R. Wright',
    average: '141.3',
    gameweekPoints: '132',
    total: '2800',
  },
  {
    variant: 'default',
    rank: '25',
    teamName: 'Empowered Minds',
    managerName: 'S. Scott',
    average: '147.6',
    gameweekPoints: '135',
    total: '3000',
  },
  {
    variant: 'default',
    rank: '26',
    teamName: 'Driven Spirits',
    managerName: 'T. Green',
    average: '153.0',
    gameweekPoints: '140',
    total: '3200',
  },
  {
    variant: 'default',
    rank: '27',
    teamName: 'Innovative Approaches',
    managerName: 'U. Adams',
    average: '149.4',
    gameweekPoints: '138',
    total: '3100',
  },
  {
    variant: 'default',
    rank: '28',
    teamName: 'Collaborative Spirits',
    managerName: 'V. Baker',
    average: '136.2',
    gameweekPoints: '126',
    total: '2900',
  },
  {
    variant: 'default',
    rank: '29',
    teamName: 'Success Seekers',
    managerName: 'W. Gonzalez',
    average: '140.9',
    gameweekPoints: '130',
    total: '2950',
  },
  {
    variant: 'default',
    rank: '30',
    teamName: 'Visionary Leaders',
    managerName: 'X. Ramirez',
    average: '152.1',
    gameweekPoints: '144',
    total: '3100',
  },
];

export const LeaderBoard = ({
  className,
  rows = defaultRows,
  showHeader = true,
  labelProps,
  labelClassName,
  rowClassName,
  showAverage = true,
  showGameweekPoints = true,
  ...otherProps
}: LeaderBoardProps) => {
  return (
    <div
      className={twMerge(
        [
          'flex w-full max-w-[846px] flex-col',
          'md:rounded-[--corner-md]',
          'md:shadow-[0px_4px_40px_0px_rgba(34,37,38,0.2)]',
        ],
        className
      )}
      {...otherProps}
    >
      <div className="flex flex-col md:overflow-hidden md:rounded-[--corner-md]">
        {showHeader ? (
          <LeaderBoardLabel
            className={labelClassName}
            showAverage={showAverage}
            showGameweekPoints={showGameweekPoints}
            {...labelProps}
          />
        ) : null}
        {rows.map((row, index) => (
          <LeaderBoardCell
            key={`${row.rank}-${index}`}
            className={rowClassName}
            showAverage={showAverage}
            showGameweekPoints={showGameweekPoints}
            {...row}
          />
        ))}
      </div>
    </div>
  );
};
